module.exports = __webpack_public_path__ + "static/media/bg-environmental.ed15e743.jpg";